import { PageHeader } from '@ksyos/design-system';
import { PageTemplate } from '@frontend/components/templates/PageTemplate';

interface IOutclinicDashboardTemplateProps {
    children: JSX.Element;
    title: string;
}

export function OutclinicDashboardTemplate(props: IOutclinicDashboardTemplateProps) {
    return (
        <PageTemplate width="large">
            <PageHeader title={props.title} />
            {props.children}
        </PageTemplate>
    );
}
